import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const multipleSclerosis: AnswerPathTreeNode = {
  path: 'multipleSclerosis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredMultipleSclerosisDetails }],
};
